<template>
  <div class="bg-white logo-search">
    <div class="container-fluid d-flex justify-content-around align-items-center position-relative">
      <div class="d-lg-none">
        <button class="navbar-toggler p-2 " type="button" data-toggle="collapse" data-target="#main-nav"
          aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation">
          <ClientOnly><i class="fa-solid fa-bars fa-xl"></i></ClientOnly>
        </button>
        <a href="#" class="btn" role="button" data-toggle="collapse" data-target="#main-search"
          aria-controls="main-search" aria-expanded="false" aria-label="Toggle navigation">
          <ClientOnly><i class="fa-solid fa-magnifying-glass fa-xl"></i></ClientOnly>
        </a>
      </div>
      <router-link :to="{ name: 'home' }" class="logo">
        <img v-if="headerLogoUrl" :src="headerLogoUrl" :alt="headerLogoAlt"  />
      </router-link>
      <b-form @submit.prevent="goSearch" aria-autocomplete="off" id="main-search"
        class="main-search collapse d-lg-block">
        <div class="input-group search-group">
          <b-form-input v-model="search" type="search" required @blur="hideSearchResultsTimer()"
            :placeholder="$t('search_for')" v-on:keyup.enter="goSearch()"
            class="form-control form-control-lg border-end-0" autocomplete="off"
            aria-label="Zoeken naar..."></b-form-input>
          <b-btn v-on:click="goSearch()" class="btn bg-white border border-start-0" id="btn-main-search" variant="light"
            squared>
            <ClientOnly>
              <i class="fa-solid fa-magnifying-glass fa-xl"></i>
            </ClientOnly>
          </b-btn>
          <div class="search-results" :class="{ show: isSearchResultsShown }">
            <span class="search--title">{{ $t("suggestions") }}:</span>
            <ul class="search-suggestions">
              <li v-for="suggestion of searchSuggestions" :key="suggestion.word" class="d-block">
                <b-link v-on:click="goRoute('/search', suggestion.word)">{{
                  suggestion.word
                }}</b-link>
              </li>
            </ul>
            <span class="search--title">{{ $t("recommended_products") }}:</span>
            <ul class="recommended-products">
              <li v-for="recommendedProduct of recommendedProducts" :key="recommendedProduct.sku"
                class="d-inline-block">
                <b-link v-on:click="goRoute('/' + recommendedProduct.url_key)" class="d-flex align-items-center"
                  @click="closeMainSearch">
                  <div class="product-img">
                    <b-img :src="recommendedProduct.thumbnail.small" :alt="recommendedProduct.name" width="41"
                      height="51" fluid></b-img>
                  </div>
                  <span class="product-name">{{
                    recommendedProduct.name
                  }}</span>
                </b-link>
              </li>
            </ul>
          </div>
        </div>
      </b-form>
      <div class="quick-links">
        <ul class="d-flex flex-wrap justify-content-center list-unstyled m-0 p-0">
          <li v-for="icon of icons" :key="icon.iconNumber"
            :class="{ 'py-3': true, dropdown: icon.menuId === 'account'}" @click.prevent="onClick(icon)"
            @mouseenter="onOver(icon)" @mouseleave="onLeave(icon)">
            <b-link class="minicart-link" v-if="icon.isEnabled" :to="icon.link" v-bind="icon.menuId === 'account'
                ? {
                  href: '#',
                  role: 'button',
                  'data-toggle': 'dropdown',
                  'aria-expanded': 'false',
                }
                : icon.menuId === 'cart'
                  ? { id: 'cart-popover' }
                  : {}
              ">
              <span class="position-relative">
                <ClientOnly>
                  <i v-if="icon.isLinearIcon" class="fa-solid" :class="icon.iconName"></i>
                  <div v-else>
                    <b-img :src="icon.iconName" width="25" height="25" :alt="icon.text" fluid></b-img>
                  </div>
                </ClientOnly>
                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger minicart-productcount"
                  v-if="icon.hasBadge" :variant="icon.badgeColor">{{ icon.badgeValue }}</span>
              </span>
              <span class="d-none d-lg-inline ms-2 minicart-title">{{ icon.text }}</span> 
            </b-link>
            <b-popover v-if="cartCount > 0" target="cart-popover" triggers="hover" placement="top"
              custom-class="minicart">
              <HeaderIconsDropdownCart v-if="
                icon.hasDropdown &&
                icon.menuId == 'cart' &&
                icon.isEnabled == true
              " :icon="icon" :showType="showType" />
            </b-popover>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <b-link @click="goAccount" class="dropdown-item">{{
                  $t("account")
                }}</b-link>
              </li>
              <li>
                <b-link @click="goLogout" class="dropdown-item">{{
                  $t("logout")
                }}</b-link>
              </li>
            </ul>
          </li>
          <li class="py-3 d-none d-md-inline dropdown country-dropdown">
            <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">
              <ClientOnly><i class="fa-solid fa-earth-europe me-1"></i></ClientOnly>
              <img :src="currentFlag" :alt="currentLanguageName" />
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a class="dropdown-item" href="#" @click="setLanguage('nl')">Dutch</a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click="setLanguage('de')">German</a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click="setLanguage('en')">English</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import getImageUrl from "@/esf_antarctica_lederhosenland/helpers/getImageUrl.js";
import Cart from "@storefront/core/modules/cart/mixins";
import ClientOnly from "vue-client-only";
import { getProductsBySearchPreview } from "@storefront/core/data-resolver/products";
import { Logger } from "@storefront/core/lib/logger";
import config from "@config";
import HeaderIconsDropdownCart from "@/esf_antarctica_lederhosenland/core/components/header/HeaderIconsDropdownCart.vue";

export default {
  mixins: [Cart],
  components: {
    ClientOnly,
    HeaderIconsDropdownCart,
  },

  data: () => ({
    search: "",
    searchlTimer: null,
    seachCloseTimer: null,
    closeSignal: null,
    output: null,
    searchSuggestions: [],
    recommendedProducts: [],
    isSearchGroupShown: false,
    isSearchResultsShown: false,
  }),
  mounted() {
    window.addEventListener("resize", this.resize);
    document.addEventListener("click", this.close);
  },
  destroyed() {
    document.removeEventListener("click", this.close);
    window.removeEventListener("click", this.resize);
  },
  props: {
    showType: { type: String },
  },
  computed: {
  headerLogo() {
    return this.$store.getters["headerlogo/getStoreLogo"];
  },

  headerLogoUrl() {
    if (!this.headerLogo) return "";

    return `${this.headerLogo.base_media_url}logo/${this.headerLogo.header_logo_src}`;
  },

  headerLogoAlt() {
    return this.headerLogo?.logo_alt || "Hendricks Carnival";
  },
    isLoggedIn() {
      return this.$store.getters["user/getIsLoggedIn"];
    },
    currentTemplate() {
      return config.template.name;
    },
    informativeSlider() {
      const data =
        this.$store.getters["sliders/getSliderByIdentifier"](
          "informative_slider"
        );
      return data;
    },
    currentFlag() {
      const flagMap = {
        en: this.imgUrl("flag-en.png"),
        nl: this.imgUrl("flag-nl.png"),
        de: this.imgUrl("flag-de.png"),
      };
      return flagMap[this.$i18n.locale] || this.imgUrl("flag-nl.png");
    },
    currentLanguageName() {
      const languageNameMap = {
        en: "English",
        nl: "Nederlands",
        de: "German",
      };
      return languageNameMap[this.$i18n.locale] || "Nederlands";
    },
    icons() {
      const icons = [
        // {
        //   iconNumber: 1,
        //   isLinearIcon: true,
        //   hasBadge: false,
        //   iconName: "lnr-map-marker",
        //   text: "Onze winkels",
        //   hasDropdown: false,
        //   link: "/winkels",
        //   isEnabled: true,
        // },
        {
          iconNumber: 2,
          isLinearIcon: true,
          hasBadge: false,
          iconName: "fa-phone",
          text: "+31 045 888 7840",
          hasDropdown: false,
          link: "#",
          isEnabled: true,
        },

        {
          iconNumber: 4,
          isLinearIcon: true,
          hasBadge: true,
          badgeValue: this.wishlistCount,
          badgeColor: "success",
          iconName: "fa-heart",
          text: this.$t("wishlist"),
          menuId: "wishList",
          isEnabled: this.isLoggedIn,
          dropHeading: this.$t("items_in_wishlist", {
            numberOf: this.wishlistCount,
          }),
          link: "/wishlist",
        },
        {
          iconNumber: 5,
          isLinearIcon: true,
          hasBadge: false,
          iconName: "fa-user",
          text: this.$t("login"),
          hasDropdown: false,
          link: "/login",
          isEnabled: !this.isLoggedIn,
        },
        {
          iconNumber: 6,
          isLinearIcon: true,
          hasBadge: false,
          iconName: "fa-user",
          text: this.$t("account"),
          menuId: "account",
          hasDropdown: true,
          isEnabled: this.isLoggedIn,
        },
        {
          iconNumber: 3,
          isLinearIcon: true,
          hasBadge: true,
          badgeValue: this.cartCount,
          badgeColor: "success",
          iconName: "fa-basket-shopping",
          text: this.$t("shopping_basket"),
          isEnabled: true,
          hasDropdown: true,
          dropHeading: this.$t("items_in_cart", { numberOf: this.cartCount }),
          dropItems: this.cartItems,
          menuId: "cart",
          cartFooter: {
            totalPrice: this.cartSubTotalPrice,
            totalTax: this.cartTotalTaxPrices,
            cartTotal: this.cartTotalPrice,
            btnText: this.$t("goto_checkout"),
            btnVariant: "success",
          },
          link: "#",
        },
      ];
      return icons.filter((icon) => icon.isEnabled);
    },
  },
  methods: {
    onClick(icon) {
      if (icon.iconName == "fa-phone") {
        window.location.href = `tel:${icon.text}`;
      }
      if (window.innerWidth <= 991) {
        this.$root.$emit(
          "bv::toggle::collapse",
          `topIconsCollapse` + this.showType + icon.iconNumber
        );
        setTimeout(() => {
          this.$root.$emit(
            "bv::toggle::collapse",
            `topIconsCollapse` + this.showType + icon.iconNumber
          );
        }, 5000);
      }
    },
    onOver(icon) {
      if (window.innerWidth > 991) {
        this.$root.$emit(
          "bv::toggle::collapse",
          `topIconsCollapse` + this.showType + icon.iconNumber
        );
      }
    },
    onLeave(icon) {
      if (window.innerWidth > 991) {
        this.$root.$emit(
          "bv::toggle::collapse",
          `topIconsCollapse` + this.showType + icon.iconNumber
        );
      }
    },
    imgUrl(fileName) {
      return getImageUrl(fileName);
    },
    setLanguage(lang) {
      this.$i18n.locale = lang; // Update the locale in vue-i18n
    },
    resize() {
      document.body.classList.add("resize-active");
      if (window.innerWidth > 575) {
        this.isSearchGroupShown = false;
      }
      clearTimeout(this.resizeTimer);
      this.resizeTimer();
    },
    resizeTimer() {
      setTimeout(() => {
        document.body.classList.remove("resize-active");
      }, 400);
    },
    toggleSearch() {
      this.isSearchGroupShown = !this.isSearchGroupShown;
    },
    close(e) {
      if (!this.$el.parentElement.contains(e.target)) {
        this.isSearchGroupShown = false;
      }
    },
    showSearchResults() {
      this.isSearchResultsShown = true;
    },
    hideSearchResults() {
      this.isSearchResultsShown = false;
    },
    async getSearchPreview() {
      const controller = new AbortController();
      const { signal } = controller;

      this.closeSignal = controller;
      this.output = await getProductsBySearchPreview(this.search, signal);
      this.closeSignal = null;

      this.recommendedProducts = this.output.items;
      this.searchSuggestions = this.output.search_suggestions;
      this.showSearchResults();
    },
    goRoute(route, query = null) {
      Logger.debug("goRoute", "HeaderSearch", route)();
      this.hideSearchResults();
      this.search = "";
      if (query != null) {
        this.$router.push({ path: route, query: { q: query } });
      } else {
        this.$router.push({ path: route });
      }
    },
    goSearch() {
      this.hideSearchResults();
      if (this.search.length > 0) {
        clearTimeout(this.searchlTimer);
        if (this.closeSignal !== null) this.closeSignal.abort();

        // this.$router.push({ path: "/search", query: { q: this.search } });
      }
    },
    goClose() {
      this.close(this);
    },
    hideSearchResultsTimer() {
      Logger.debug("hideSearchResultsTimer", "HeaderSearch", null)();
      this.seachCloseTimer = setTimeout(
        function (scope) {
          scope.search = "";
          scope.hideSearchResults();
        },
        300,
        this
      );
    },
    goAccount() {
      this.$router.push("/account");
    },
    goLogout() {
      setTimeout(() => {
        this.$store.dispatch("user/logout");
        this.$router.push("/");
      }, 100);
    },
    closeMainSearch() {
      if (
        document &&
        document.getElementById("main-search") &&
        document.getElementById("main-search").classList
      ) {
        document.getElementById("main-search").classList.remove("show");
      }
    },
  },
  watch: {
    search() {
      if (this.search.length > 2) {
        if (this.searchlTimer !== null) {
          clearTimeout(this.searchlTimer);
        }
        this.searchlTimer = setTimeout(
          function (scope) {
            if (scope.closeSignal !== null) {
              scope.closeSignal.abort();
            }
            scope.getSearchPreview();
          },
          300,
          this
        );
      } else {
        this.hideSearchResults();
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.nav-form {
  flex-grow: 1;
  margin-left: 16px;
  font-size: 20px;
  margin-top: -5px;
}
.search-group {
  position: relative;
  .search-input {
    font-size: 16px;
    padding-right: 33px;
    border-radius: 4px;
    border: 0;
   &::placeholder {
      font-size: 13px;
      letter-spacing: -0.02em;
    }
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
}

.search-btn {
  background: none !important;
  border: none !important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  line-height: 1;
  right: 0;
  font-size: 20px;
  padding: 4px 12px;
  svg {
    color: $primaryColor;
    font-size: 16px;
  }
}
.close-btn {
  display: none;
}
.search-results {
  position: absolute;
  // left: 0;
  right: 0;
  top: 100%;
  width: 100%;
  z-index: 999;
  display: none;
  background: $white;
  font-size: 15px;
  padding: 15px 10px 10px 10px;
  box-shadow: 0px 5px 5px 1px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 5px 5px;

  &.show {
    display: block;
  }
  &>.search--title {
    padding-bottom: 0;
  }
}

.search-suggestions,
.recommended-products {
  list-style: none;
  margin: 0;
}

.search-suggestions {
  border-bottom: 1px solid $borderColor;
  margin-bottom: 10px;
  padding-bottom: 5px;
  li {
    a {
      color: $primaryColor;
      font-size: 12px;
    }
  }
}

.search--title {
  font-size: 12px;
  font-weight: 600;
  display: block;
  color: #0d1f47;
  padding-bottom: 10px;
}

.recommended-products {
  margin-top: 10px;
  .product-img {
    width: 40px;
    flex-shrink: 0;
    img {
      width: 100%;
    }
  }
  .product-name {
    padding-left: 10px;
    color: $primaryColor;
    font-size: 12px;
  }

  li {
    +li {
      margin-top: 10px;
    }
  }
}

.main-search {
  z-index: 999;
}
.logo>img {
  @media screen and (min-width: 640px) {
    width: 262px;
  }
}
</style>
